import * as PIXI from 'pixi.js';
import { MenuScene } from "@/scenes/menu-scene";
import { WIDTH, HEIGHT } from '@/constants';
import { createPopupPanel, createText, createMenuItem, style} from '@/ui/menu-builder';
import { bounce } from '@/util/tween';
import { EVENT_BUS } from '@/model/event-bus';

export class SelectModeScene extends MenuScene {
    constructor() {
        super("select-mode"); // this is the scene name
        this.initHeaders();
    }

    initHeaders() {
        const header = new PIXI.Text('Pick a game-mode', {
            ...style,
            fontSize: 50,
            align: 'left',
        });
        header.anchor.set(0.5, 0.5);
        header.position.set(255, 40);
        this.addChild(header);
        const sub = new PIXI.Text('Sheet music might be intimidating, but it\'s not', {
            ...style,
            align: 'left',
            fontSize: 24
        });
        // sub.anchor.set(0.5, 0.5);
        sub.position.set(20, 80);
        this.addChild(sub);
        this.sub = sub;
    }

    initPanel() {
        this.showSelectModePopup();
    }

    initButtons() {
        const back = createMenuItem({
            text: 'Back',
            yCoord: HEIGHT - 70,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'select-song'
            }
        });

        this.addChild(back);
        back.position.set(WIDTH - 120, 60);
        this.buttons = [...this.buttons, back];
    }

    showSelectModePopup() {
        const mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        mask.tint = 0x000000;
        mask.alpha = 0.8;
        this.addChild(mask);
        [
            { screenshot: '2dmode.jpg', id: 'game-2d', name: '2D Mode', text: 'Inspired by keyboardmania' },
            { screenshot: 'musicMode.jpg', id: 'game-notation', name: 'Notation mode', text: 'Music Notation mode,\n akin to yousician' },
            { screenshot: '3dmode.jpg', id: 'game-3d', name: '3D Mode', text: 'Inspired by Rock band 3\n and Rocksmith' },
        ].forEach((obj, index) => {
            const screenshot = PIXI.Sprite.from(`public/images/screenshots/${obj.screenshot}`);
            const popupPanel = createPopupPanel({
                variation: '06',
                headerText: obj.name,
                text: ''
            });

            const text = createText({
                text: obj.text,
                fontSize: 16
            });
            text.y = 100;
            popupPanel.__meta = {
                clickActionName: 'SELECT_MODE',
                clickActionPayload: {
                    payload: obj.id
                }
            }
            popupPanel.addChild(text);
            this.addChild(popupPanel);
            screenshot.width = 200;
            screenshot.height = 120;
            screenshot.anchor.set(0.5, 0.5);
            popupPanel.addChild(screenshot);
            popupPanel.x = WIDTH / 3 * index + WIDTH / 6;
            bounce(popupPanel);
            this.buttons.push(popupPanel)

            popupPanel.interactive = true;
            popupPanel.buttonMode = true;
            popupPanel.on('pointerover', () => {
                EVENT_BUS.emit('MENU_HOVER', { sprite: popupPanel, mouseOver: true });
            });
            popupPanel.on('pointerout', () => {
                EVENT_BUS.emit('MENU_HOVER', { sprite: popupPanel, mouseOver: false });
            });
            popupPanel.on('pointerdown', (e) => {
                EVENT_BUS.emit('MENU_CLICK', {
                    sprite: popupPanel,
                    actionName: 'SELECT_MODE',
                    actionPayload: {
                        payload: obj.id
                    }
                });
            });
        })
        mask.width = WIDTH;
        mask.height = HEIGHT;
        mask.position.set(WIDTH / 2, HEIGHT / 2);
        mask.anchor.set(0.5, 0.5);
    }

    onReveal() {
        // override menu-scene cancelling practice mode
    }

}